/*
 * janice-cart.js — additive cart enhancements for the Janice Stevia build.
 *
 * Prestige's <free-shipping-bar> element (theme.js) already updates the message text on
 * cart:change. It does NOT draw a visual bar, so this script drives the prune fill width.
 *
 * The fill is computed from the data-fsb-* attributes the snippet renders in cents, so it is
 * correct on first paint and does not depend on Prestige's custom-element upgrade order.
 * Prestige re-renders the cart-drawer section on every cart change, which replaces the bar in
 * the DOM with fresh server-computed totals — a MutationObserver catches those re-renders, and
 * a cart:change listener updates any bar that persists in place.
 */
(function () {
  'use strict';

  var SELECTOR = '.free-shipping-bar';

  function applyFill(bar, totalCents) {
    var threshold = parseFloat(bar.getAttribute('data-fsb-threshold')) || 0;
    var total = typeof totalCents === 'number'
      ? totalCents
      : parseFloat(bar.getAttribute('data-fsb-total')) || 0;

    var ratio = threshold > 0 ? Math.min(1, Math.max(0, total / threshold)) : 1;
    bar.style.setProperty('--fsb-progress', (ratio * 100).toFixed(2) + '%');
    bar.toggleAttribute('data-fsb-reached', ratio >= 1);
  }

  // Mirror Prestige's own calculation so the fill stays in sync with the message text.
  function totalFromCartEvent(cart) {
    if (!cart) return null;
    var items = cart.items || [];
    var price = items
      .filter(function (item) { return item.requires_shipping; })
      .reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    var discount = (cart.cart_level_discount_applications || [])
      .reduce(function (sum, d) { return sum + d.discount_application.total_allocated_amount; }, 0);
    return price - discount;
  }

  function refreshAll(totalCents) {
    document.querySelectorAll(SELECTOR).forEach(function (bar) {
      applyFill(bar, totalCents);
    });
  }

  // Live update for bars that persist between renders.
  document.addEventListener('cart:change', function (event) {
    var total = event.detail && totalFromCartEvent(event.detail.cart);
    refreshAll(typeof total === 'number' ? total : undefined);
  });

  // Catch freshly re-rendered bars (drawer open, add-to-cart, quantity change).
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SELECTOR)) {
          applyFill(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll(SELECTOR).forEach(function (bar) { applyFill(bar); });
        }
      }
    }
  });

  function start() {
    refreshAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
